import { Logo } from "@assets"

export default function AppLogo() {
  return (
    <>
      <img src={Logo} alt="logo" className="h-[30px] w-auto" />
    </>
  )
}
